// extracted by mini-css-extract-plugin
export default {"ellipsis":"YbQYj_fBcSnRRNbjCs1C__ellipsis___","noWrap":"iJfdq20kqelIkA58JFPE__noWrap___"};